import { Component, ChangeDetectionStrategy } from "@angular/core";
import { NgOptimizedImage } from "@angular/common";
import { RouterLink } from "@angular/router";
import { scrollToSection } from "../../utils/scroll-to";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NgOptimizedImage],
})
export class FooterComponent {
  public readonly currentYear = new Date().getFullYear();

  public scrollTo(id: string): void {
    scrollToSection(id);
  }
}
